export function validateByEmailDomainFilter(
  userEmailDomain: string,
  domains: string[]
): boolean {
  if (domains.length === 0) {
    return true;
  }

  const userEmailDomainLower = userEmailDomain.toLowerCase();

  return domains.some(domain => {
    let domainFormatted = domain.toLowerCase();

    if (domainFormatted.startsWith('@')) {
      domainFormatted = domainFormatted.substring(1); // Remove @
    }

    return userEmailDomainLower === domainFormatted;
  });
}
